module.exports = __webpack_public_path__ + "img/satan_skear.9a8049d5.png";